const authorizationOrganizationFakes = [
    {
        id: '9be8c02e-7ad4-4e86-9609-062c95739ad9',
        name: 'External Party Example',
        description: '3rd Party',
        address: {
            streetAddress: 'Test Saskatchewan Drive',
            city: 'Regina',
            province: 'Saskatchewan',
            country: 'CAN',
            postalCode: 'S4P1Z8',
        },
        organizationType: 'ExternalPartners',
    },
    {
        id: '3cf25675-f7cd-5afa-8d08-356cf541cd84',
        name: 'Knight Archer Insurance Ltd',
        description: 'I0233-06',
        address: {
            streetAddress: '100-716 Main Street',
            city: 'Humboldt',
            province: 'Saskatchewan',
            country: 'CAN',
            postalCode: 'S0K2A0',
        },
        organizationType: 'Issuers',
    },
    {
        id: '03d8e9ee-9d4f-547c-bdf0-ed64bebe8f68',
        name: 'Knight Archer Insurance Ltd',
        description: 'I0233-12',
        address: {
            streetAddress: '2402 Westwood Dr',
            city: 'Humboldt',
            province: 'Saskatchewan',
            country: 'CAN',
            postalCode: 'S0K2A0',
        },
        organizationType: 'Issuers',
    },
    {
        id: '92f32c21-ed69-5cf5-b881-11e18935d902',
        name: 'Harvard Western Insurance',
        description: 'I0236-15',
        address: {
            streetAddress: '109 Souris Street',
            city: 'Yellow Grass',
            province: 'Saskatchewan',
            country: 'CAN',
            postalCode: 'S0G5J0',
        },
        organizationType: 'Issuers',
    },
    {
        id: '43685489-b502-5e9a-8223-f000fc7c35b5',
        name: 'Harvard Western Insurance',
        description: 'I0236-23',
        address: {
            streetAddress: '407 Broad Street',
            city: 'Regina',
            province: 'Saskatchewan',
            country: 'CAN',
            postalCode: 'S4R1X4',
        },
        organizationType: 'Issuers',
    },
    {
        id: '5da35ba7-7ac0-484a-ad7b-b43b5bf000e0',
        name: 'SPS',
        description: 'SPS',
        address: {
            streetAddress: '111 Random Ave',
            city: 'Regina',
            province: 'Saskatchewan',
            country: 'CAN',
            postalCode: 'S6R0P2',
        },
        organizationType: 'LawEnforcement',
    },
    {
        id: '03712cae-d5f2-58d4-815d-9fc5d82c8ba6',
        name: 'SGI CANADA - NAGS',
        description: 'SGI',
        address: null,
        organizationType: 'AfDivision',
    },
    {
        id: 'bcdb54d3-c743-5257-a7fe-d936d69e0f44',
        name: 'SGI Canada Misc Claims Expenses',
        description: 'SGI',
        address: null,
        organizationType: 'ClaimsDivision',
    },
    {
        id: '4cbb6b59-e653-5ef3-9c25-97eb6470771c',
        name: 'SGI Head Office',
        description: 'SGI',
        address: null,
        organizationType: 'AfDivision',
    },
    {
        id: 'fc8406c5-2cf1-47db-8ba7-6f58701e993e',
        name: 'Underwriter Example',
        description: 'Underwriter',
        address: {
            streetAddress: 'Test College Drive',
            city: 'Regina',
            province: 'Saskatchewan',
            country: 'CAN',
            postalCode: 'S4P1Z9',
        },
        organizationType: 'Underwriters',
    },
];
export { authorizationOrganizationFakes };
